<template>
  <header class="header">
    <div class="header-middle sticky-header">
      <div class="container header-top-bar-container">
        <div class="header-left">
          <router-link :to="{ name: 'Home' }" class="logo">
            <img src="/assets/images/logo.png" alt="Eurosan Logo" />
          </router-link>
        </div>
        <!-- End .header-left -->

        <div class="header-center header-center-search d-none d-lg-block">
          <div class="header-search">
            <a href="#" class="search-toggle" role="button">
              <i class="icon-magnifier"></i>
            </a>
            <form @submit.prevent.stop="handleSearchSubmit()">
              <div class="header-search-wrapper">
                <input
                  type="search"
                  class="form-control"
                  name="q"
                  id="q"
                  :placeholder="translations.find"
                  v-model="searchInput"
                  @input="handleSearch"
                  @focus="handleSearchFocus"
                  @blur="handleBlur()"
                />

                <ul
                  class="article-list bg-body"
                  v-if="showSearchResults && searchInput.trim().length >= minimumSearchLength"
                >
                  <li v-if="articles.length === 0" class="article-list-empty">
                    <span class="article-wrapper">
                      <div class="article-title text-body">
                        Nema prijedloga za "{{ searchInput.trim() }}"
                      </div>
                    </span>
                  </li>
                  <li v-for="article in articles" :key="article.id">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: article.id, slug: slugify(article.title) },
                      }"
                      class="article-wrapper"
                      @click.native="handleSuggestionSelect"
                    >
                      <img
                        v-if="article.highlightedImageUrl"
                        :src="`${baseUrl}${article.highlightedImageUrl}`"
                        class="article-image"
                      />

                      <img v-else class="article-image" :src="'img/products/product-8.jpg'" />
                      <div class="article-description">
                        <div class="article-title">
                          {{ article.title }}
                        </div>
                        <div class="article-code">
                          {{ article.code }}
                        </div>
                        <div v-if="(!article.disableSelling && canViewPrices) ||
                          canPassRestrictions" style="display: flex;
                         gap: 1px; align-items: start;">
                          <div
                            class="article-price"
                            v-if="article.salePrice && article.salePrice < article.price"
                          >
                            {{ article.salePrice | money3WithCurrency }}
                            <span
                            class="old-price"
                            v-if="article.salePrice && article.salePrice < article.price"
                          >
                            <del> {{ article.price | money3 }} KM</del>
                          </span>
                          </div>
                          <div class="article-price" v-else>
                            {{ article.price | money3WithCurrency }}
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </li>
                  <li @click="handleSearchSubmit">
                    <a class="article-wrapper">
                      <div class="article-title text-body">Za više rezultata pritisnite Enter</div>
                    </a>
                  </li>
                </ul>

                <button class="btn" type="button" @click="handleSearchSubmit()">
                  <i class="icon-magnifier"></i>
                </button>
              </div>
              <!-- End .header-search-wrapper -->
            </form>
          </div>
          <!-- End .header-search -->
        </div>
        <!-- End .headeer-center -->

        <div class="header-right d-none d-md-flex">
          <div class="header-user">
            <router-link class="position-relative" :to="{ name: 'ProfileDashboard' }">
              <i class="icon-user-2"></i>
              <span class="unread-messages-count position-absolute" v-if="unreadMessageCount > 0">
                {{ unreadMessageCount }}
              </span>
              <!-- <span
                class="
                  position-absolute
                  top-0 start-100
                  translate-middle
                  badge rounded-pill
                  bg-danger
                "
              >
                99+
              </span> -->
            </router-link>
            <div class="header-userinfo">
              <span
                >{{ translations.greetings }} {{ profile.userData.firstName }}! ({{
                  profile.userData.companyTitle.toUpperCase()
                }})</span
              >
              <div class="header-dropdown">
                <h4>
                  <router-link :to="{ name: 'ProfileDashboard' }">
                    {{ translations.myAccount }}
                  </router-link>
                </h4>
                <div class="header-menu">
                  <ul>
                    <li>
                      <router-link exact :to="{ name: 'ProfileDashboard' }">
                        <i class="icon-cog" /> {{ translations.controlPanel }}
                      </router-link>
                    </li>
                    <li>
                      <a href="#" @click.stop.prevent="logOut()">
                        <i class="sicon-logout" /> {{ translations.logout }}
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- End .header-menu -->
              </div>
            </div>
          </div>

          <div class="dropdown cart-dropdown whishlist-dropdown">
            <router-link
              :to="{ name: 'Wishlist' }"
              class="dropdown-toggle wishlist-toggle"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-display="static"
            >
              <i class="icon icon-heart"></i>
              <span class="cart-count wishlist-count" v-if="wishlist.length > 0">
                {{ wishlist.length }}
              </span>
            </router-link>

            <div class="dropdown-menu">
              <div class="dropdownmenu-wrapper">
                <div class="dropdown-cart-header">
                  <span v-if="wishlist.length > 0">{{ wishlist.length }}
                     {{ translations.products }}</span>
                  <span v-else>{{ translations.wishListIsEmpty }}</span>

                  <router-link :to="{ name: 'Wishlist' }">{{ translations.wishlist }}</router-link>
                </div>
                <!-- End .dropdown-cart-header -->
                <vue-custom-scrollbar
                  class="dropdown-cart-products wishlist scroll-area"
                  :settings="scrollbarSettings"
                >
                  <div class="product" v-for="item in wishlist" :key="item.id">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: { id: item.articleId, slug: slugify(item.title) },
                        }"
                      >
                        <Photo :src="`${baseUrl}${item.imageUrl}`" v-if="item.imageUrl" />
                        <Photo src="assets/images/no-image.jpg" v-else />
                      </router-link>
                      <a
                        href="#"
                        class="btn-remove"
                        @click.stop.prevent="toggleWishlistItem(item.articleId)"
                        title="Remove Product"
                      >
                        <i class="icon-retweet"></i>
                      </a>
                    </figure>
                    <div class="product-details">
                      <h4 class="product-title">
                        <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.title) },
                          }"
                        >
                          {{ item.title }}
                        </router-link>
                      </h4>
                      <span>{{ translations.forms.labels.code }}: {{ item.code }}</span>
                    </div>
                    <!-- End .product-details -->
                  </div>
                </vue-custom-scrollbar>
                <!-- End .product -->
                <!-- End .cart-product -->
              </div>
              <!-- End .dropdownmenu-wrapper -->
            </div>
            <!-- End .dropdown-menu -->
          </div>

          <div class="dropdown cart-dropdown">
            <router-link
              :to="{ name: 'ShoppingCart' }"
              class="dropdown-toggle"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-display="static"
            >
              <i class="minicart-icon"></i>
              <span class="cart-count" v-if="cart && cart.cartItems">
                {{ cart.cartItems.length || 0 }}
              </span>
            </router-link>

            <div class="dropdown-menu" v-if="cart && cart.cartItems">
              <div class="dropdownmenu-wrapper">
                <div class="dropdown-cart-header">
                  <span>{{ cart.cartItems.length }} {{ translations.products }}</span>
                  <router-link :to="{ name: 'ShoppingCart' }">{{
                    translations.shoppingCart
                  }}</router-link>
                </div>
                <!-- End .dropdown-cart-header -->
                <div class="dropdown-cart-products wishlist scroll-area">
                  <div class="product" v-for="item in cart.cartItems" :key="item.id">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: { id: item.articleId, slug: slugify(item.article) },
                        }"
                      >
                        <img
                          :src="`${baseUrl}${item.highlightedImageUrl}`"
                          v-if="item.highlightedImageUrl"
                          alt="product"
                        />
                        <img src="assets/images/no-image.jpg" v-else alt="product" />
                      </router-link>
                      <a href="#" class="btn-remove" @click.stop.prevent="removeFromCart(item.id)">
                        <i class="icon-retweet" />
                      </a>
                    </figure>
                    <div class="product-details">
                      <h4 class="product-title">
                        <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.article) },
                          }"
                        >
                          {{ item.article }}
                        </router-link>
                      </h4>
                      <div>{{ translations.forms.labels.code }}:
                        {{ item.variation?.article?.code ?? item.code }}
                      </div>

                      <span class="cart-product-info" v-if="canViewPrices">
                        <span class="cart-product-qty">{{ item.quantity }}</span>
                        x {{ item.price | money3WithCurrency }}
                      </span>
                    </div>
                    <!-- End .product-details -->
                  </div>
                  <!-- End .product -->
                </div>
                <!-- End .cart-product -->

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.totalWithoutTax }}</span>
                  <span class="cart-total-price">
                    {{ cart.totalAmountWithoutVat.toFixed(2) }} KM
                  </span>
                </div>

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.totalTax }}</span>
                  <span class="cart-total-price">{{ cart.totalAmountVat.toFixed(2) }} KM</span>
                </div>

                <div class="dropdown-cart-total" v-if="canViewPrices">
                  <span>{{ translations.total }}</span>
                  <span class="cart-total-price">{{ cart.totalAmount.toFixed(2) }} KM</span>
                </div>
                <!-- End .dropdown-cart-total -->

                <div class="dropdown-cart-action">
                  <router-link :to="{ name: 'Checkout' }" class="btn btn-block">
                    {{ translations.checkout }}
                  </router-link>
                </div>
                <!-- End .dropdown-cart-total -->
              </div>
              <!-- End .dropdownmenu-wrapper -->
            </div>
            <!-- End .dropdown-menu -->
          </div>
          <!-- End .dropdown -->
        </div>
        <!-- End .header-right -->

        <div class="header-mobile-actions d-flex d-lg-none">
          <button
            class="header-mobile-action"
            type="button"
            aria-label="Open search"
            :aria-expanded="isMobileSearchOpen ? 'true' : 'false'"
            @click="toggleMobileSearch"
          >
            <i class="icon-magnifier"></i>
          </button>
          <button
            class="mobile-menu-toggler header-mobile-action"
            type="button"
            aria-label="Open menu"
            @click="handleMobileMenuToggle"
          >
            <i class="icon-menu"></i>
          </button>
        </div>
      </div>
      <!-- End .container -->
    </div>
    <!-- End .header-middle -->

    <div v-show="isMobileSearchOpen" class="mobile-search-strip d-lg-none">
      <div class="container">
        <div class="header-search mobile-header-search">
          <form @submit.prevent.stop="handleSearchSubmit()">
            <div class="header-search-wrapper mobile-search-wrapper">
              <input
                ref="mobileSearchInput"
                v-model="searchInput"
                type="search"
                class="form-control"
                name="mobile-q"
                :placeholder="translations.find"
                @input="handleSearch"
                @focus="handleSearchFocus"
                @blur="handleBlur()"
              />

              <ul
                v-if="showSearchResults && searchInput.trim().length >= minimumSearchLength"
                class="article-list bg-body"
              >
                <li v-if="articles.length === 0" class="article-list-empty">
                  <span class="article-wrapper">
                    <div class="article-title text-body">
                      Nema prijedloga za "{{ searchInput.trim() }}"
                    </div>
                  </span>
                </li>
                <li v-for="article in articles" :key="`mobile-${article.id}`">
                  <router-link
                    :to="{
                      name: 'Article',
                      params: { id: article.id, slug: slugify(article.title) },
                    }"
                    class="article-wrapper"
                    @click.native="handleSuggestionSelect"
                  >
                    <img
                      v-if="article.highlightedImageUrl"
                      :src="`${baseUrl}${article.highlightedImageUrl}`"
                      class="article-image"
                    />

                    <img v-else class="article-image" :src="'img/products/product-8.jpg'" />
                    <div class="article-description">
                      <div class="article-title">
                        {{ article.title }}
                      </div>
                      <div class="article-code">
                        {{ article.code }}
                      </div>
                      <div
                        v-if="((!article.disableSelling && canViewPrices) || canPassRestrictions)"
                        style="display: flex; gap: 1px; align-items: start;"
                      >
                        <div
                          class="article-price"
                          v-if="article.salePrice && article.salePrice < article.price"
                        >
                          {{ article.salePrice | money3WithCurrency }}
                          <span
                            class="old-price"
                            v-if="article.salePrice && article.salePrice < article.price"
                          >
                            <del> {{ article.price | money3 }} KM</del>
                          </span>
                        </div>
                        <div class="article-price" v-else>
                          {{ article.price | money3WithCurrency }}
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
                <li @click="handleSearchSubmit">
                  <a class="article-wrapper">
                    <div class="article-title text-body">Za više rezultata pritisnite Enter</div>
                  </a>
                </li>
              </ul>

              <button class="btn" type="button" @click="handleSearchSubmit()">
                <i class="icon-magnifier"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="header-bottom">
      <div class="container">
        <nav class="main-nav">
          <div class="menu-depart" @click="toggleMenu">
            <a><i class="icon-menu"></i>{{ translations.categories.toUpperCase() }}</a>
          </div>
          <ul class="menu">
            <router-link :to="{ name: 'Home' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.homePageTitle }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'MyArticles' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate"> {{ translations.myArticles }} </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Orders' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.orders }}
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Brands' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate"> {{ translations.brands }} </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Sales' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.sales }}
                  <span
                    class="badge badge-pill position-absolute sales-badge"
                    v-if="sales.length > 0"
                  >
                    {{ sales.length }}
                  </span>
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'Blogs' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.news }}
                </a>
              </li>
            </router-link>

            <router-link :to="{ name: 'About' }" v-slot="{ href, isExactActive, navigate }" custom>
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.aboutUs }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'Contact' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ active: isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.contact }}
                </a>
              </li>
            </router-link>
          </ul>
        </nav>
        <a href="https://webshop.eurosan.ba/">
          <div class="ml-auto b2c-button">
            {{ translations.physicalPersons }}
          </div>
        </a>

        <div class="header-dropdowns"
         v-if="!useDefaultLanguage && defaultLanguages">
          <div class="header-dropdown">
            <a href="#">{{ lang.shortTitle.toUpperCase() }}</a>
            <div class="header-menu">
              <ul>
                <li
                  v-for="lang in defaultLanguages"
                  :key="lang.id"
                >
                <a href="#" @click="setLanguage(lang.id)">
                  {{ lang.title.toUpperCase() }}
                </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="categories && categories.length > 0">
        <div class="sub-menu-container">
          <ul id="submenu-height" class="submenu" :class="{ opened: menuActive }">
            <li class="main-category" v-for="item in categories" :key="item.id">
              <router-link
                class="main-category-label"
                @click.native="hideMenu()"
                :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }"
              >
                {{ item.label }} <i class="icon-angle-right" />
              </router-link>
              <div class="main-menu-open" v-if="item.children && item.children.length > 0">
                <div class="col-12">
                  <div class="category-wrapper">
                    <div class="sub-category-wrapper" v-for="sub in item.children" :key="sub.id">
                      <div>
                        <router-link
                          @click.native="hideMenu()"
                          :to="{
                            name: 'Category',
                            params: {
                              id: sub.id,
                              slug: sub.slug,
                            },
                          }"
                        >
                          {{ sub.label }}
                        </router-link>
                      </div>

                      <ul
                        class="menu-column-3-level"
                        v-if="sub.children && sub.children.length > 0"
                      >
                        <li v-for="subSub in sub.children" :key="subSub.id">
                          <router-link
                            @click.native="hideMenu()"
                            :to="{
                              name: 'Category',
                              params: {
                                id: subSub.id,
                                slug: subSub.slug,
                              },
                            }"
                          >
                            {{ subSub.label }}
                          </router-link>
                        </li>
                        <li>
                          <router-link
                            @click.native="hideMenu()"
                            :to="{ name: 'Category', params: { id: sub.id, slug: sub.slug } }"
                            class="text-underline"
                          >
                            {{ translations.viewAll }} <i class="icon-angle-right" />
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <router-link
                    :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }"
                    class="view-all"
                  >
                    {{ translations.viewAllFrom }} {{ item.label }}
                  </router-link>
                </div>
                <!-- <div class="col-lg-4 d-lg-block d-sm-none no-gaps">
                  <div class="menu-column">
                    <img style="margin-left: auto" src="assets/images/banners/menu-banner.jpg" />
                  </div>
                </div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- End .header-bottom -->
    </div>
    <!-- End .header-bottom -->
    <div>
      <!-- Bottom navigation for mobile -->
      <div class="fixed-bottom d-md-none bg-light border-top custom-bottom-bar">
        <div class="container">
          <div class="bottom-nav-list">
            <div class="bottom-nav-item">
              <router-link :to="{ name: 'Home' }" class="bottom-nav-link">
                <i class="icon-home bottom-nav-icon"></i>
                <span class="bottom-nav-label">{{ translations.homePageTitle }}</span>
              </router-link>
            </div>

            <div class="bottom-nav-item">
              <router-link :to="{ name: 'ProfileDashboard' }" class="bottom-nav-link">
                <i class="icon-user-2 bottom-nav-icon"></i>
                <span class="bottom-nav-label">{{ translations.myProfile }}</span>
              </router-link>
            </div>

            <div class="bottom-nav-item">
              <router-link :to="{ name: 'Wishlist' }" class="bottom-nav-link">
                <i class="icon icon-heart bottom-nav-icon"></i>
                <span class="bottom-nav-label">{{ translations.wishlist }}</span>
                <span
                  class="badge badge-pill badge-danger position-absolute bottom-nav-badge"
                  v-if="wishlist.length > 0"
                >
                  {{ wishlist.length }}
                </span>
              </router-link>
            </div>

            <div class="bottom-nav-item">
              <router-link :to="{ name: 'ShoppingCart' }" class="bottom-nav-link">
                <i class="icon-bag bottom-nav-icon"></i>
                <span class="bottom-nav-label">{{ translations.shoppingCart }}</span>
                <span
                  class="badge badge-pill badge-danger position-absolute bottom-nav-badge"
                  v-if="cart && cart.cartItems && cart.cartItems.length > 0"
                >
                  {{ cart.cartItems.length }}
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { debounce } from 'lodash';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import './scrollbar.css';

import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';

import { translations, categoryMenu } from '@/mixins';
import Photo from '@/components/shared/Image.vue';

export default {
  name: 'Header',
  components: {
    vueCustomScrollbar,
    Photo,
  },
  mixins: [translations, categoryMenu],
  data() {
    return {
      scrollbarSettings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      minimumSearchLength: 3,
      showSearchResults: false,
      isMobileSearchOpen: false,
      searchInput: '',
    };
  },
  computed: {
    categories() {
      return this.$store.getters.getCategoriesTreeView;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    baseUrl() {
      return config.baseUrl;
    },
    articles() {
      return (this.$store.getters.getSearchArticles || {}).articles || [];
    },
    route() {
      return this.$route.name;
    },
    unreadMessageCount() {
      return this.$store.getters.getUnreadMessagesCount;
    },
    sales() {
      return this.$store.getters.getArticlesOnSale;
    },
    useDefaultLanguage() {
      return this.$store.getters.getUseDefaultLanguage;
    },
    defaultLanguage() {
      return this.$store.getters.getDefaultLanguage;
    },
    defaultLanguages() {
      return this.$store.getters.getLanguages.map((lang) => ({
        ...lang,
        title: this.languages.find((item) => item.id === lang.id)?.title || lang.title,
        shortTitle: this.languages.find((item) => item.id === lang.id)?.shortTitle
        || lang.shortTitle,
      }));
    },
  },
  methods: {
    slugify,
    handleMobileMenuToggle(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.closeMobileSearch();
      document.body.classList.toggle('mmenu-active');
    },
    closeMobileSearch() {
      this.isMobileSearchOpen = false;
      this.showSearchResults = false;
    },
    toggleMobileSearch() {
      this.isMobileSearchOpen = !this.isMobileSearchOpen;

      if (!this.isMobileSearchOpen) {
        this.showSearchResults = false;
        return;
      }

      this.$nextTick(() => {
        if (this.$refs.mobileSearchInput) {
          this.$refs.mobileSearchInput.focus();
        }
      });
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getWishList');
      });
    },
    logOut() {
      api.logout().finally(() => {
        localStorage.removeItem('token');
        this.$router.push({ name: 'Login' });
      });
    },
    removeFromCart(cartItemId) {
      api.removeFromCart(cartItemId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
      });
    },
    handleSearchSubmit() {
      const search = this.searchInput.trim();
      const currentRouteSearch = this.$route.params.search
        ? this.$route.params.search.trim().toLowerCase()
        : '';

      if (
        search.length < this.minimumSearchLength
        || (this.$route.name === 'Search'
        && currentRouteSearch === search.toLowerCase())
      ) {
        return;
      }
      this.showSearchResults = false;
      this.closeMobileSearch();
      this.$router.push({ name: 'Search', params: { search } });
    },
    handleBlur: debounce(function blur() {
      this.showSearchResults = false;
    }, 180),
    handleSearchFocus() {
      if (this.searchInput.trim().length >= this.minimumSearchLength) {
        this.showSearchResults = true;
      }
    },
    handleSuggestionSelect() {
      this.showSearchResults = false;
      this.closeMobileSearch();
    },
    handleSearch: debounce(function search() {
      const quickSearch = this.searchInput.trim();

      // Needs to enter minimun 3 characters to perform search
      if (quickSearch.length < this.minimumSearchLength) {
        this.showSearchResults = false;
        return;
      }

      this.showSearchResults = true;
      this.$store.dispatch('getQuickSearch', {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        pageSize: 6,
        quickSearch,
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      });
    }, 200),
  },
  mounted() {
    this.$store.dispatch('getWishList');
    this.$store.dispatch('getUnreadMessagesCount');
    Porto.stickyHeader();
  },
  watch: {
    '$route.fullPath': function resetSearchState() {
      this.searchInput = '';
      this.closeMobileSearch();
    },
    useDefaultLanguage(value) {
      if (value) {
        const defaultLanguage = this.$store.getters.getDefaultLanguage;
        localStorage.setItem('langId', defaultLanguage);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// .whishlist-dropdown {
//   line-height: 0.5rem;
//   margin-top: 4px;
// }
/* Custom styles for the bottom bar */

// mobilni prikaz

.header-top-bar-container {
  align-items: center;
}

.header-center-search {
  margin-left: 3rem;
}

.header-center-search .header-search {
  width: 100%;
}

.header-center-search .header-search form {
  width: 100%;
}

.header-mobile-actions {
  margin-left: auto;
  gap: 0.5rem;
}

.header-mobile-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.4rem;
  height: 4.4rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #1f2933;
}

.header-mobile-action i {
  font-size: 2.4rem;
}

.header-mobile-action.mobile-menu-toggler {
  display: flex;
  margin-right: 0;
  font-size: inherit;
  color: inherit;
}

.custom-bottom-bar {
  min-height: 6rem;
  padding: 0.5rem 0 calc(0.5rem + env(safe-area-inset-bottom));
  z-index: 1030;
}

.bottom-nav-list {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
}

.bottom-nav-item {
  position: relative;
  flex: 1 1 25%;
  display: flex;
  justify-content: center;
  min-width: 0;
}

.bottom-nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  padding-top: 0.45rem;
  padding-bottom: 0.15rem;
  color: #000;
  text-align: center;
  text-decoration: none;
}

.bottom-nav-link:hover {
  color: #1e84bc;
}

.bottom-nav-icon {
  font-size: 2.2rem;
  line-height: 1;
}

.bottom-nav-label {
  display: block;
  font-size: 1rem;
  line-height: 1.1;
  white-space: nowrap;
}

.bottom-nav-badge {
  top: 0.35rem;
  right: calc(50% - 1.9rem);
  min-width: 1.8rem;
  padding: 0.2rem 0.45rem;
  font-size: 0.9rem;
}

.sales-badge {
  top: 11px;
  right: 29px;
  font-size: 0.85rem;
  height: 10px;
  width: 10px;
  background-color: #e27c7c;
  color: #e27c7c;
}

@media screen and (max-width: 1269px) {
  .sales-badge {
    top: -3px;
    right: 0px;
    font-size: 0.85rem;
    height: 9px;
    width: 9px;
    background-color: #e27c7c;
    color: #e27c7c;
  }
}

// mobilni prikaz kraj

.sub-menu-container {
  background: transparent;
  border: none;
  width: 275px;
  // width: 100%;
}

.submenu {
  margin-left: 20px;
  background: transparent;
  border: #f0f0f0;

  &:hover {
    width: 100%;
  }

  li.main-category {
    display: flex;
    height: 31.7px;
    color: #767f84;
    line-height: 1.4;
    border: #f0f0f0;

    &:hover {
      background: #1e84bc;
      color: #fff;

      .main-menu-open {
        display: flex;
        left: 0;
      }
    }

    a.main-category-label {
      padding-left: 8px;
      color: #212529;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-basis: 100%;
      margin: 0 1rem;
      text-transform: uppercase;
      font-size: 1.3rem;
      color: #212529;
      font-weight: 600;
      border-bottom: none;

      &:hover {
        color: #fff;

        i {
          color: #fff;
        }
      }

      i {
        color: #212529;
        font-weight: 600;
        font-size: 1.9rem;
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .submenu {
    margin-left: 10px;
  }
}

.main-category {
  width: 275px;
  color: #767f84;
  background: #fff;
}

.main-menu-open {
  display: none;
  position: absolute;
  top: 0;
  width: calc(100% - 275px);
  bottom: 0;
  background: #fff;
  transition: all 2s;
}

.menu-depart {
  color: #fff !important;

  a {
    color: #fff !important;
    font-weight: bold !important;
  }

  .icon-menu {
    color: #fff !important;
  }
}

#submenu-height {
  border-top: 1px solid #e7e7e7;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.09);
  border-bottom: 6px solid #1e84bc;
}
.category-wrapper {
  color: #222529;
  font: 600 1.5rem /1.1 'Open Sans', sans-serif;
  letter-spacing: 0.01em;
  text-transform: none;
  padding-top: 10px;
  columns: 3;
  // rows: 5;
  column-gap: 40px;
  height: 100%;

  .sub-category-wrapper {
    padding-bottom: 20px;
    width: 100%;
    break-inside: avoid;
    color: #212529;

    a {
      display: inline-block;
      margin-bottom: 1.5rem;
      color: #212529;
      font-weight: bold;
      font-size: 14px;
      transition: all 0.5s;

      &:hover {
        color: #1e84bc;
      }
    }
  }
}

.menu-column-3-level li a {
  font: 600 1.2rem 'Open Sans', sans-serif !important;
  line-height: 20px;
  height: 20px;
  // color: #777 !important;
  color: #212529;
  cursor: pointer;
  padding: 0 !important;
  margin: 0 !important;
  text-transform: none !important;
}
.text-underline {
  text-decoration: underline;
}

.view-all {
  position: absolute;
  right: 10px;
  bottom: 20px;
  text-transform: uppercase;
  font-size: 18px;
  color: #222529;
  padding: 0 10px 5px 10px;
  border-bottom: 1px solid #777;
  font-size: 14px;
  color: #777;
  transition: all 0.5s;

  &:hover {
    color: #1e84bc;
    border-bottom: 1px solid #1e84bc;
  }
}

.cart-dropdown .dropdown-toggle .cart-count.wishlist-count {
  right: 12px;
}

.wishlist-toggle {
  i {
    font-size: 27px;
  }
}

.dropdown-menu {
  z-index: 1002;
}

.dropdown-cart-products.wishlist {
  max-height: 450px;
  overflow: auto;
}

@media screen and (max-width: 1479px) {
  .main-category {
    width: 230px;
  }

  .main-menu-open {
    width: calc(100% - 230px);
  }
}

.article-list {
  position: absolute;
  margin-top: 0;
  border: 1px solid #ced4da;
  border-radius: 1.6rem;
  list-style: none;
  padding: 0;
  z-index: 1080;
  left: 0;
  top: calc(100% + 0.8rem);
  width: 100%;
  background: #fff;
  box-shadow: 0 18px 36px rgb(15 23 42 / 14%);
  overflow: hidden;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    opacity: 0.75;

    &:first-child {
      border-top: none;
    }

    &:hover {
      opacity: 1;
      .article-title {
        color: #259ddf;
        text-decoration: underline;
      }
    }
  }
}

.article-list-empty {
  cursor: default !important;
}

.article-wrapper {
  display: flex;
  flex-basis: 50%;
}

.article-description {
  display: flex;
  flex-direction: column;
  height: 80px;
  color: #777;
}

.article-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 5px;
}

.product-image {
  display: block;
  width: 70px;
  height: 70px;
}

.product-image-container {
  margin-right: 5px;
}

.article-title,
.article-code,
.article-price {
  width: 100%;
  font-size: 16px;
  flex-basis: 50%;
}

.sticky-header {
  margin-right: 0 !important;
}

.cart-dropdown .dropdown-toggle .minicart-icon {
  border: 2px solid #1e84bc;
}

.cart-dropdown .dropdown-toggle .minicart-icon:hover {
  border: 2px solid black;
}

.unread-messages-count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  right: 1.25rem;
  top: 0;
  border-radius: 50%;
  padding-bottom: 3px;
  font-size: 1rem;
  font-weight: 600;
  background-color: #ed7e63;
  color: #fff;
  box-shadow: 0 7px 8px rgb(0 0 0 / 5%);
}

.icon-cog,
.sicon-logout {
  font-size: 1.5rem !important;
  border: none;
}

.dropdown-cart-header,
.dropdown-cart-total {
  padding: 0.25rem 1rem;
  font-size: 13px;
}

.dropdown-cart-total .cart-total-price {
  font-size: 13px;
}

.b2c-button {
  background-color: #1e84bc;
  color: white;
  padding-inline: 17px;
  padding-block: 8px;
  font: 400 13px 'Poppins', 'Open Sans', sans-serif;
}

.b2c-button:hover {
  background-color: #259ddf !important;
}

@media (max-width: 991px) {
  .header {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #f8f8f8;
  }

  .header-middle.sticky-header {
    position: relative;
    top: auto;
    z-index: auto;
    box-shadow: none;
    border-bottom: 1px solid #dfe8ef;
  }

  .header-top-bar-container {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .header-left {
    flex: 1 1 auto;
  }

  .mobile-search-strip {
    padding: 0.8rem 0 1rem;
    border-bottom: 1px solid #dfe8ef;
    box-shadow: none;
    background: #f8f8f8;
  }

  .mobile-search-strip .header-search {
    width: 100%;
    margin-left: 0;
  }

  .mobile-search-strip .header-search form {
    margin-bottom: 0;
  }

  .mobile-search-strip .header-search .header-search-wrapper {
    display: flex !important;
    position: relative !important;
    right: auto !important;
    top: auto !important;
    width: 100% !important;
    min-width: 0 !important;
    margin-top: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent;
    z-index: auto !important;
  }

  .mobile-search-strip .header-search .header-search-wrapper:before {
    display: none !important;
    content: none !important;
  }

  .mobile-search-strip .header-search .form-control {
    height: 5.2rem;
    font-size: 1.6rem;
    padding-left: 1.8rem;
    border: 1px solid #d7e4ee;
    border-top: 1px solid #d7e4ee;
    border-bottom: 1px solid #b3b6b8;
    border-left: 1px solid #bec1c4;
    border-right: none;
    border-radius: 1.6rem 0 0 1.6rem;
    box-shadow: none;
  }

  .mobile-search-strip .header-search .btn {
    flex: 0 0 5.2rem;
    border-radius: 0 1.6rem 1.6rem 0;
    border: 1px solid #1e84bc;
    border-left: none;
    background-color: #1e84bc;
    color: #fff;
    box-shadow: none;
  }

  .mobile-search-strip .header-search .btn:hover,
  .mobile-search-strip .header-search .btn:focus {
    color: #fff;
    background-color: #259ddf;
    border-color: #259ddf;
  }

  .mobile-search-strip .header-search .btn i {
    font-size: 1.9rem;
  }

  .mobile-search-strip .header-search .header-search-wrapper .article-list {
    max-height: min(52vh, 38rem);
    overflow-y: auto;
  }

  .article-list {
    max-height: min(52vh, 38rem);
    overflow-y: auto;
  }

  .article-image {
    width: 6.8rem;
    height: 6.8rem;
    margin-right: 1rem;
  }

  .article-title,
  .article-code,
  .article-price {
    font-size: 1.4rem;
  }

  .header-bottom {
    display: none;
  }

  .custom-bottom-bar {
    min-height: 6.6rem;
    padding-top: 0.6rem;
    border-top-color: #dfe8ef !important;
    background: rgb(255 255 255 / 96%) !important;
    backdrop-filter: blur(14px);
    box-shadow: 0 -10px 24px rgb(15 23 42 / 10%);
    z-index: 1060;
  }

  .bottom-nav-label {
    font-size: 0.9rem;
  }

  .bottom-nav-badge {
    top: 0.45rem;
    right: calc(50% - 1.6rem);
  }
}
</style>
